import { render, staticRenderFns } from "./RecordItem.vue?vue&type=template&id=b31696e4&scoped=true&"
import script from "./RecordItem.vue?vue&type=script&lang=js&"
export * from "./RecordItem.vue?vue&type=script&lang=js&"
import style0 from "./RecordItem.vue?vue&type=style&index=0&id=b31696e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b31696e4",
  null
  
)

export default component.exports